import { StatusEnum } from '../../Enum/StatusEnum';
import { Homicide } from '../MiniMentalExams/Homicide.model';
import { HomicideAssaultRisk } from '../MiniMentalExams/HomicideAssaultRisk.model';

import { Suicide } from '../MiniMentalExams/Suicide.model';
import { SuicideRiskType } from '../MiniMentalExams/SuicideRiskType.model';

export default interface ISuicidalHomicidalIdeations {
    Id: string;
    MemberId: string;
    MemberName: string;
    Homicide: Homicide;
    HomicideAssaultRisk: HomicideAssaultRisk;
    Suicide: Suicide;
    SuicideRiskType: SuicideRiskType;
    CreatedDate: string;
    CreatedBy: string;
    UpdatedDate: string;
    UpdatedBy: string;
    Status: StatusEnum;
}

export class SuicidalHomicidalIdeations implements ISuicidalHomicidalIdeations {
    Id: string;
    MemberId: string;
    MemberName: string;
    Homicide: Homicide;
    HomicideAssaultRisk: HomicideAssaultRisk;
    Suicide: Suicide;
    SuicideRiskType: SuicideRiskType;
    CreatedDate: string;
    CreatedBy: string;
    UpdatedDate: string;
    UpdatedBy: string;
    Status: StatusEnum;

    constructor() {
        this.Id = '';
        this.MemberId = '';
        this.MemberName = '';
    }
}
